<template>
  <div class="header">
    <el-button type="primary" size="small" @click="logout">注销账号</el-button>
  </div>
</template>
<script>
import cookie from '~/utils/cookie'
export default {
  name: 'layoutContainerHeader',
  methods: {
    // 注销账号
    logout () {
      cookie.remove('token')
      this.$router.push('/login')
    }
  }
}
</script>
<style lang="scss" scoped>
  .header {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    height:50px;
    padding-right: 40px;
    background-color: #ffffff;
    box-shadow:0px 0px 10px rgba(53,53,53,0.15);
    z-index: 1915;
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/container/header/index.vue